<template>
    <form id="bloc-form" @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="grid">
            <div class="col-12">
                <as-title class="title"
                    :title="$t('rituals.bloc_form.' + (bloc.id ? 'edit_bloc_title' : 'new_bloc_title'))" :size="3" />
            </div>
            <div class="field col-12">
                <div class="p-float-label">
                    <InputText type="text" v-model="v$.libelle.$model" class="w-100"
                        :class="{ 'p-invalid': v$.libelle.$invalid && submitted }" />
                    <label>{{ $t("rituals.bloc_form.bloc_label") }}</label>
                </div>
                <as-input-error :errors="v$.libelle.$silentErrors" v-show="submitted" />
            </div>
            <!-- Liste des sujets -->

            <div class="col-12">
                <div class="flex w-100">
                    <as-title :title="$t('rituals.bloc_form.bloc_subject_title')" :size="3"></as-title>
                    <div class="ml-auto">
                        <Button :label="$t('rituals.bloc_form.bloc_new_subject_button_label')" class="button-default"
                            @click="addSubject" />
                    </div>
                </div>
                <div v-for="(sujet, index) in state.sujets" :key="index" class="field ">
                    <div class="p-float-label flex">
                        <InputText type="text" v-model="state.sujets[index].libelle" class="flex-1"
                            :class="{ 'p-invalid': v$.sujets[index]?.libelle.$invalid && state.submitted }" />
                        <Button icon="pi pi-trash" class="p-button-danger ml-2" @click="removeSujet(index)" />
                    </div>
                    <as-input-error v-if="v$.sujets[index]" :errors="v$.sujets[index].libelle.$silentErrors"
                        v-show="state.submitted" />
                </div>
            </div>
        </div>
        <div class="grid fixed-bottom">
            <div class="col flex justify-content-end">
                <Button :label="$t('form.cancel_button')" class="button-default"
                    :icon="isSending ? 'pi pi-spin pi-spinner' : 'pi pi-times'" @click="onClose"
                    :disabled="isSending" />
                <Button type="submit" :label="$t('form.submit_button')" class="button-primary ml-2"
                    :icon="isSending ? 'pi pi-spin pi-spinner' : 'pi pi-check'" :disabled="isSending" />
            </div>
        </div>
    </form>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "@vuelidate/validators"
import { reactive, computed, watch } from "vue"

import AsTitle from "../Elements/AsTitle.vue"
import Button from "primevue/button"
import InputText from "primevue/inputtext"
import AsInputError from "../Forms/AsInputError.vue"

export default {
    name: "BlocForm",
    components: {
        AsTitle,
        Button,
        InputText,
        AsInputError,
    },
    props: {
        bloc: Object,
        isSending: Boolean,
    },
    setup(props) {
        const state = reactive({
            libelle: "",
            sujets: [{ libelle: "" }],
            submitted: false,
        })
        const rules = computed(() => ({
            libelle: { required },
            sujets: state.sujets.map(() => ({
                libelle: {},
            })),
        }))
        const v$ = useVuelidate(rules, state)
        watch(() => props.bloc, (bloc) => {
            if (bloc) {
                state.libelle = bloc.libelle || "";
                state.sujets = bloc.sujets ? bloc.sujets.map(sujet => ({ ...sujet })) : [{ libelle: "" }];
            }
        }, { deep: true, immediate: true });
        return { v$, state }
    },
    data() {
        return {
            submitted: false,
        }
    },
    validations() {
        return {
            libelle: { required },
        }
    },
    emits: ["onClose", "onSubmit"],
    methods: {
        handleSubmit(isFormValid) {
            this.submitted = true
            if (!isFormValid) {
                return;
            }
            const bloc = {
                id: this.bloc.id,
                libelle: this.state.libelle,
                sujets: [...this.state.sujets].filter(e => e.libelle.trim() !== "")
            }
            this.submitted = false
            this.$emit("onSubmit", bloc)
        },
        onClose() {
            this.state.libelle = ""
            this.state.sujets = [{ libelle: "" }]
            this.submitted = false
            this.$emit("onClose");
        },
        addSubject() {
            this.state.sujets = [...this.state.sujets, { id: 0, libelle: "" }]
        },
        removeSujet(index) {
            this.state.sujets.splice(index, 1)
        },
    },
};
</script>
